import { render, staticRenderFns } from "./priceHistoryTab.vue?vue&type=template&id=4bc6ecd0&scoped=true&"
import script from "./priceHistoryTab.vue?vue&type=script&lang=js&"
export * from "./priceHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./priceHistoryTab.vue?vue&type=style&index=0&id=4bc6ecd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6ecd0",
  null
  
)

export default component.exports
import {QScrollArea,QInput,QCarousel,QCarouselSlide,QCard,QTable,QTr,QTh,QPopupProxy,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QInput,QCarousel,QCarouselSlide,QCard,QTable,QTr,QTh,QPopupProxy,QTd})
